import { styled } from "@mui/material/styles";

const StyledPrivateLayout = styled("div")(
  ({ theme }) => `
  .dashboard-layout {
   box-shadow: none !important;
  }
  .dashboard-title {
    margin-left: 260px;
    font-family: Lexend;
    color: ${theme.palette.primary.main};
    font-weight: 500;
    font-size: 24px;
    font-style: normal;
    line-height: 22px;
    @media screen and (max-width: 900px) {
      margin-left: 0px;
    }
  }
  .hamberger-icon {
    color: ${theme.palette.primary.main} !important; 
  }
  .mune-wrap {
    display: flex;
    align-items: anchor-center;
  }    
  .profile {
    padding: 20px 20px;
  }  

  .profile-image {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid ${theme.palette.customColor.secondaryThird};
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .profile-image-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }  
  .profile-details {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .profile-store-text {
    font-family: Lexend;
    color: ${theme.palette.customColor.secondarySecond};
    font-weight: 400;
    font-size: 11px;
    font-style: normal;
    line-height: 14px;
  }
  .profile-name-text {
    font-family: Lexend;
    color: ${theme.palette.primary.main};
    font-weight: 400;
    font-size: 16px;
    font-style: normal;
    line-height: 20px;
    letter-spacing: -2%;
  }
  .drawer-headers {
    font-family: Lexend;
    color: ${theme.palette.customColor.secondarySecond};
    font-weight: 400;
    font-size: 11px;
    font-style: normal;
    line-height: 14px;
    margin: 10px 40px;
  }
  .drawer-links {
    text-decoration: none;
    width: 230px;
  }
  .drawer-main-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    padding : 4px 10px;
  }
  
  .drawer-main-icon {
    min-width: 0px !important;
    width: 22px;
    "& .MuiSvgIcon-root": {
      stroke: "0.1px",
      strokeWidth: "0.1px"
    }
  }  
  .drawer-main-text {
    font-family: Lexend;
    color: ${theme.palette.customColor.secondarySecond};
    font-weight: 400;
    font-size: 14px !important;
    line-height: 22px;
  }
  .active {
    background: rgba(167, 141, 120, 0.15);
  }
  .active-text {
    color: ${theme.palette.primary.main};
  }
  .toolbar {
    background: ${theme.palette.customColor.white};
    box-shadow: none;
  }

  .profileButton {
    position: relative;
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    color: ${theme.palette.primary.main}
  }
  .iconBackground {
    font-size: 22px;
    color: ${theme.palette.primary.main}
  } 
  .userName: {
    font-family: Lexend;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: ${theme.palette.primary.main}
    }
  .dropdownMenu {
    position: absolute;
    top: 54px !important;
    right: 9% !important;
    left: auto !important;
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 10;
    width: 200px;
  }
  .dropDownRow1 {
    display: flex;
    align-items: center;
    gap: 20px;
    background-color: transparent !important;
    }
  .dropDownRow2: {
    marginTop: 10px;
    background-color: transparent !important;
  }
  .mune-wrap-desktop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .dorpDownUserName {
    font-family: Lexend;
    color: ${theme.palette.primary.main};
    font-weight: 500;
    font-size: 16px;
    font-style: normal;
    line-height: 20px;
  }
  .dorpDownViewProfile {
    font-family: Lexend;
    color: ${theme.palette.primary.main};
    font-weight: 400;
    font-size: 14px;
    font-style: normal;
    line-height: 18px;
    text-decoration: underline;
  }
}
.logout-btn {
  text-transform: none;
  font-family: Lexend;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  text-transform: none;
  color: ${theme.palette.customColor.white};
  background-color: ${theme.palette.primary.main};
  border-radius: 0px;
  padding: 10px 20px;
  width: 100%;
}      
            
              
`
);

export default StyledPrivateLayout;
